module.exports = __webpack_public_path__ + "img/stock5.c38b579f.png";